/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
class t{constructor(t,e=null){this.labelText=e,this.elevationOffset=t??0}}export{t as Graphics3DObjectMetadata};
